import {
  CHANGE_LANGUAGE,
  GET_SETTINGS_REQUEST,
  GET_SETTINGS_SUCCESS,
  GET_SETTINGS_FAILURE,
  GET_SPA_SETTINGS_REQUEST,
  GET_SPA_SETTINGS_SUCCESS,
  GET_SPA_SETTINGS_FAILURE,
} from '@store/setting/actions';

export const initialState = {
  userLanguage: null,
  isSettingsFetching: false,
  isSpaSettingsFetching: false,
  languages: null,
  currencies: null,
};

export default (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case CHANGE_LANGUAGE: {
      return {
        ...state,
        userLanguage: payload,
      };
    }
    case GET_SETTINGS_REQUEST:
      return {
        ...state,
        isSettingsFetching: true,
      };
    case GET_SETTINGS_SUCCESS: {
      return {
        ...state,
        isSettingsFetching: false,
        ...payload,
        countryPhonePrefixes: Object.entries(payload.countryPhonePrefixes)
          .filter(([_, countryCode]) => !!countryCode)
          .map(([countryName, countryCode]) => ({
            value: countryCode,
            label: `${countryName.toUpperCase()} : ${countryCode || ''}`,
          }))
          .sort((a, b) => a.label.localeCompare(b.label)),
        countryCodes: payload.countryCodes
          ? Object.entries(payload.countryCodes)
              .map(([value, label]) => ({
                value,
                label,
              }))
              .sort((a, b) => a.label.localeCompare(b.label))
          : [],
      };
    }
    case GET_SETTINGS_FAILURE:
      return {
        ...state,
        isSettingsFetching: false,
      };
    case GET_SPA_SETTINGS_REQUEST: {
      return {
        ...state,
        isSpaSettingsFetching: true,
      };
    }
    case GET_SPA_SETTINGS_SUCCESS: {
      return {
        ...state,
        isSpaSettingsFetching: false,
        ...payload,
      };
    }
    case GET_SPA_SETTINGS_FAILURE: {
      return {
        ...state,
        isSpaSettingsFetching: false,
      };
    }
    default:
      return state;
  }
};
